module.exports = "<div>\n  <h3 class=\"text-center\">Currently there are no faqs of type {{ target }} </h3>\n</div>"